import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { createAgentContactSchema } from '../../../contacts/validators/schemas/create-agent-contact.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { AgentTypeEnum } from '../../enums/agent-type.enum';

/**
 * Schema for new agent record validation.
 */
export const createAgentSchema = () =>
  Joi.object({
    color: Joi.string().optional().allow(null, ''),

    // Type
    type: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|agent-type|cannot-be-null',
        }),
        otherwise: Joi.string()
          .valid(...Object.values(AgentTypeEnum))
          .required()
          .messages({
            'any.required': 'validations|agent-type|required',
            'any.only': 'validations|agent-type|invalid-value',
          }),
      })
      .required()
      .messages({
        'any.required': 'validations|agent-type|required',
      })
      .prefs({ abortEarly: true }),

    // Contact
    contact: createAgentContactSchema(),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|agent-notes|must-be-string',
    }),

    agentCategoryId: Joi.number().allow(null).integer().messages({
      'number.base': 'validations|agent-category-id|must-be-number',
    }),

    // Tags
    tags: createTagsSchema().messages({
      'array.base': 'validations|agent-tags|invalid-value',
    }),

    policies: createPoliciesAssignSchema(AppSubjectEnum.AGENT),

    files: Joi.any().allow(null),
  });
